import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

function AddUser() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [active, setActive] = useState("0");
  const [role, setRole] = useState("0");
  const [center, setCenter] = useState("");

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [center_list, setCenter_list] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axios.get(`${API_URL}/get_center_list`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => {
        setCenter_list(res.data.center_list || []);
        console.log("Center List:", res.data.center_list);
      })
      .catch((err) => {
        console.error("Center list error:", err);
      });
  }, []);


  const [usernameError, setUsernameError] = useState("");
  const checkUsername = async (value) => {
    setUsername(value);

    if (!value) {
      setUsernameError("");
      return;
    }

    try {
      const res = await axios.get(`${API_URL}/check-username`, {
        params: { username: value },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.exists) {
        setUsernameError("This username is already taken.");
        // alert("Username already exists! Please choose another.");

        setErrorMsg("Username already exists! Please choose another");

        setTimeout(() => setErrorMsg(""), 1000);


        setUsername("");
      } else {
        setUsernameError("");
      }
    } catch (error) {
      console.error(error);
    }
  };



  const handleChange = (e) => {
    setActive(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${API_URL}/create`,
        { username, password, email, active, role, center },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // alert(response.data.message);
      // navigate("/user_list");

      setSuccessMsg(response.data.message || "Add successfully");
      setErrorMsg("");

      setTimeout(() => {
        navigate("/UserList");
      }, 1000);


      setUsername("");
      setPassword("");
      setEmail("");
      setActive("0");
      setRole("0");
      setCenter("");

    } catch (error) {
      console.error(error);
      // alert("Error adding user!");
      setErrorMsg("Error adding user!");

      setTimeout(() => setErrorMsg(""), 1000);
    } finally {
      setIsSubmitting(false);

    }
  };

  return (
    <div className="container mt-4" style={{ backgroundColor: "#f0f8ff", minHeight: "70vh", padding: "20px" }}>
      {successMsg && (
        <div className="alert alert-success mt-2">
          {successMsg}
        </div>
      )}

      {errorMsg && (
        <div className="alert alert-danger mt-2">
          {errorMsg}
        </div>
      )}

      <h3 className="d-flex justify-content-between align-items-center mt-4">
        Add User
        <Link className="btn btn-sm btn-primary" to="/UserList">
          List
        </Link>
      </h3>

      <Form onSubmit={handleSubmit} autoComplete="off">
        <Row>
          <Col xs={12} md={6} className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => checkUsername(e.target.value)} autoComplete="off"
              required tabIndex={1}
            />{usernameError && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {usernameError}
              </div>
            )}
          </Col>

          <Col xs={12} md={6} className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)} autoComplete="new-password"
              required tabIndex={2}
            />
          </Col>

          <Col xs={12} md={6} className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)} autoComplete="off" tabIndex={3} required
            />
          </Col>

          <Col xs={12} md={6} className="mb-3">
            <Form.Label className="d-block">Active</Form.Label>
            <Form.Check
              inline
              label="Yes"
              name="active"
              type="radio"
              value="0" tabIndex={4}
              checked={active === "0"}
              onChange={handleChange}
            />
            <Form.Check
              inline
              label="No"
              name="active"
              type="radio"
              value="1"
              checked={active === "1"}
              onChange={handleChange}
            />


          </Col>
          <Col xs={12} md={6} className="mb-3">
            <Form.Label className="d-block">Role</Form.Label>
            <Form.Check inline label="Principal Investigator" name="role" type="radio" value="1" checked={role === "1"} onChange={(e) => setRole(e.target.value)} /> <Form.Check inline label="User Login" name="role" type="radio" value="0" tabIndex={5} checked={role === "0"} onChange={(e) => setRole(e.target.value)} />
          </Col>
          <Col xs={12} md={6} className="mb-3">
            <label className="form-label"><b>Select Center</b></label>
            <select
              className="form-select"
              value={center} required
              onChange={(e) => setCenter(e.target.value)}
            >
              <option value="">-- Select Center --</option>

              {center_list.map((c) => (

                <option key={c.centres_id} value={c.centres_id}>{c.center_name}</option>

              ))}

            </select>
          </Col>
          <Col xs={12} className="d-flex justify-content-center mt-3">
            <Button type="submit" className="px-4" tabIndex={6} disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}              </Button>
          </Col>
        </Row>
      </Form>
    </div>

  );
}

export default AddUser;
